import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaBell, FaArrowRight, FaArrowLeft, FaPaperPlane, FaUserCheck, FaSave } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import axios from 'axios';
import SummernoteEditor from '../qcm/summernote';
import Select from "react-select";
import { getAuthToken } from '../../../authToken';

const Liste_notifications = ({ titre }) => {
    useAuth();
    const [notifications, setNotifications] = useState([]);
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [diffusions, setDiffusions] = useState([]);
    const [groupes, setGroupes] = useState([]);
    const user_id = localStorage.getItem('user_id');

    const [expandedMessages, setExpandedMessages] = useState({}); // État pour suivre les messages étendus

    const [selectedNotification, setSelectedNotification] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showClocheModal, setShowClocheModal] = useState(false);
    const [newNotification, setNewNotification] = useState({});
    const [modifNotification, setModifNotification] = useState({});
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader
    const [isGlobaleLoading, setIsGlobaleLoading] = useState(false); // Pour gérer le loader



    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Notifications"; // Définit le titre de la page
        }
    }, [user_id]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = notifications.length;

    const navigate = useNavigate();




    // Ouvrir/Fermer le modal Ajouter
    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => {
        setNewNotification('');
        setShowAddModal(false)
        setAlertModal({ message: '', type: '' });
    };


    const handleShowEditModal = () => setShowEditModal(true);
    const handleCloseEditModal = () => setShowEditModal(false);


    const handleShowDetailsModal = () => setShowDetailsModal(true);
    const handleCloseDetailsModal = () => setShowDetailsModal(false);


    const handleShowClocheModal = () => setShowClocheModal(true);
    const handleCloseClocheModal = () => setShowClocheModal(false);





    const fetchUtilisateurs = async () => {
        try {

            const token = localStorage.getItem('access_token');

            // Envoi au backend
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            const data = await response.json();
            setUtilisateurs(data.map(user => ({
                value: user.id,
                label: `${user.nom} ${user.prenoms}`
            })));

        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };


    const fetchGroupes = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-groupe-globale/');
            if (response.ok) {
                const data = await response.json();
                setGroupes(data.map(groupe => ({
                    value: groupe.id,
                    label: groupe.nom
                })));
            } else {
                console.error('Erreur lors de la récupération des groupes');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Fetching notifications data from API
    const fetchNotifications = async () => {
        setIsGlobaleLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-notifications/');
            if (response.ok) {
                const data = await response.json();
                setNotifications(data);
            } else {
                console.error('Erreur lors de la récupération des notifications');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsGlobaleLoading(false)
        }
    };

    const fetchDiffusions = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-diffusion/');
            if (response.ok) {
                const data = await response.json();
                setDiffusions(data.map(listeDiff => ({
                    value: listeDiff.id,
                    label: `${listeDiff.nom}`
                })));
            } else {
                console.error('Erreur lors de la récupération des listes de diffusion');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchGroupes();
        fetchNotifications();
        fetchUtilisateurs();
        fetchDiffusions();
    }, []);


    const handleInputChange = (e) => {
        const { name, value } = e.target || e; // Au cas où e.target serait indéfini, on prend directement e

        // Si l'événement vient de ReactQuill, on prend la valeur du texte
        if (e.target instanceof HTMLDivElement) {
            setNewNotification({
                ...newNotification,
                [name]: value,
            });
        } else {
            setNewNotification({
                ...newNotification,
                [name]: value,
            });
        }
    };

    const handleInputModifChange = (e) => {
        const { name, value } = e.target || e; // Au cas où e.target serait indéfini, on prend directement e

        // Si l'événement vient de ReactQuill, on prend la valeur du texte
        if (e.target instanceof HTMLDivElement) {
            setModifNotification({
                ...modifNotification,
                [name]: value,
            });
        } else {
            setModifNotification({
                ...modifNotification,
                [name]: value,
            });
        }
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target || e; // Pour les autres champs de formulaire

    //     // Si l'événement provient de ReactSelect (avec isMulti activé)
    //     if (Array.isArray(e)) {
    //       setNewNotification({
    //         ...newNotification,
    //         [name]: e, // e est un tableau d'objets sélectionnés
    //       });
    //     } else {
    //       setNewNotification({
    //         ...newNotification,
    //         [name]: value, // Pour les champs classiques comme les textes
    //       });
    //     }
    //   };



    const handleEnregNotification = async () => {
        setIsLoading(true);
        try {
            let body;
            let headers = {};

            if (newNotification.typeDestinataire === 'excel' && newNotification.fichierExcel) {
                // Cas fichier Excel - utiliser FormData
                const formData = new FormData();
                formData.append('titre', newNotification.titre);
                formData.append('message', newNotification.message);
                formData.append('typeDestinataire', newNotification.typeDestinataire);
                formData.append('fichier_excel', newNotification.fichierExcel);
                body = formData;
            } else {
                // Cas normal - envoyer en JSON
                headers['Content-Type'] = 'application/json';
                body = JSON.stringify({
                    titre: newNotification.titre,
                    message: newNotification.message,
                    typeDestinataire: newNotification.typeDestinataire,
                    destinataireDetails: newNotification.destinataireDetails
                });
            }

            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-notification/`, {
                method: 'POST',
                headers: headers,
                body: body
            });

            const data = await response.json();
            if (response.ok) {
                showAlert('Notification enregistrée avec succès');
                handleCloseAddModal();
                fetchNotifications();
                setNewNotification({});
            } else {
                // console.error('Erreur lors de l'enregistrement:', data.error);
                showAlertModal(data.error || "Erreur lors de l'enregistrement", 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlertModal("Une erreur est survenue", 'danger');
        } finally {
            setIsLoading(false);
        }
    };


    // const handleEnvoyerNotification = async (e) => {
    //     setIsLoading(true); // Affiche le loader sur le bouton
    //     e.preventDefault();
    //     try {
    //         const response = await fetch(process.env.REACT_APP_HOTE + '/envoyer-notification-direct/', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(newNotification),
    //         });

    //         if (response.ok) {
    //             showAlert('Notification envoyée avec succès');
    //             handleCloseAddModal(); // Affiche le loader sur le bouton
    //             setNewNotification('');
    //         } else {
    //             const data = await response.json();
    //             console.error('Erreur lors de l’envoi de la notification');
    //             console.log(data);
    //         }
    //     } catch (error) {
    //         console.error('Erreur:', error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };


    const handleEnvoyerNotification = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const formData = new FormData();

            // Ajoutez tous les champs au FormData
            formData.append('titre', newNotification.titre);
            formData.append('message', newNotification.message);
            formData.append('typeDestinataire', newNotification.typeDestinataire);

            // Si c'est un fichier Excel, l'ajouter au FormData
            if (newNotification.typeDestinataire === 'excel' && newNotification.fichierExcel) {
                formData.append('fichier_excel', newNotification.fichierExcel);
            } else {
                // Pour les autres types de destinataires
                formData.append('destinataireDetails', JSON.stringify(newNotification.destinataireDetails));
            }

            const response = await fetch(process.env.REACT_APP_HOTE + '/envoyer-notification-direct/', {
                method: 'POST',
                body: formData, // Pas besoin de headers pour FormData
            });

            if (response.ok) {
                showAlert('Notification envoyée avec succès');
                handleCloseAddModal();
                setNewNotification({});
            } else {
                const data = await response.json();
                console.error('Erreur lors de l\'envoi:', data);
                showAlert(data.error || 'Erreur lors de l\'envoi', 'error');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert('Une erreur est survenue', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEnvoyer = async (notification) => {
        setIsLoading(true); // Affiche le loader sur le bouton
        if (!notification) {
            console.error("Aucune notification sélectionnée.");
            return;
        }

        try {

            // Requête POST vers l'API pour envoyer la notification
            const response = await fetch(process.env.REACT_APP_HOTE + `/envoyer-notification-id/${selectedNotification.id}/`, {
                method: "POST",
            });

            // Gérer la réponse
            if (response.ok) {
                const data = await response.json();
                console.log("Notification envoyée avec succès:", data.message);
                setIsLoading(false); // Affiche le loader sur le bouton

                // Afficher une alerte ou mettre à jour l'interface utilisateur
                showAlert("Notification envoyée avec succès !");
                fetchNotifications()
                setSelectedNotification(null)
                setNewNotification('');
            } else {
                const errorData = await response.json();
                console.error("Erreur lors de l'envoi:", errorData.error);
                showAlert("Erreur lors de l'envoi: " + errorData.error);
            }
        } catch (error) {
            console.error("Erreur réseau ou serveur:", error);
            showAlert("Une erreur réseau s'est produite. Veuillez réessayer plus tard.");
        } finally {
            setIsLoading(false)
        }
    };




    const fetchNotificationModif = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-notification/${selectedNotification.id}/`);
            if (!response.ok) {
                throw new Error('Erreur lors de la récupération de la notification.');
            }
            const data = await response.json();

            // Mettre à jour l'état avec les données récupérées
            setModifNotification(data.notification);
            // console.log('données récupérées :', data.notification);
        } catch (error) {
            console.error('Erreur lors de la récupération des données de la notification :', error);
            // showAlert('Impossible de charger les données de la notification.');
        } finally {
            setIsLoading(false); // Désactive le spinner
        }
    };


    useEffect(() => {

        fetchNotificationModif();
    }, [selectedNotification]); // Dépendance sur notificationId




    const handleModifierNotification = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const formData = new FormData();

            // Ajouter les champs texte
            formData.append('titre', modifNotification.titre);
            formData.append('message', modifNotification.message);
            formData.append('typeDestinataire', modifNotification.type_destinataire);
            formData.append('statut', modifNotification.statut);

            // Gestion des destinataires selon le type
            if (modifNotification.type_destinataire !== 'excel') {
                formData.append('destinataireDetails', JSON.stringify(modifNotification.destinataireDetails));
            } else if (modifNotification.fichierExcel) {
                // Si c'est un fichier Excel et qu'un nouveau fichier a été sélectionné
                formData.append('fichier_excel', modifNotification.fichierExcel);
            }
            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }

            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-notification/${selectedNotification.id}/`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                showAlert(data.message);
                fetchNotifications();
                handleCloseEditModal();
            } else {
                showAlertModal(data.error || "Erreur lors de la modification", 'danger');
            }
        } catch (error) {
            console.error("Erreur:", error);
            showAlertModal("Une erreur est survenue", 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        fetchNotifications();
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    // Handle row click
    const handleRowClick = (notification) => {
        setSelectedNotification(notification);
    };

    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // Filter notifications by search term
    const filteredNotifications = notifications.filter((n) =>
        n.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        n.message.toLowerCase().includes(searchTerm.toLowerCase()) ||
        n.type_destinataire.toLowerCase().includes(searchTerm.toLowerCase()) ||
        n.date_creation.toLowerCase().includes(searchTerm.toLowerCase()) ||
        n.statut.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort notifications
    const sortedNotifications = [...filteredNotifications].sort((a, b) => {
        if (sortConfig.key) {
            const aValue = a[sortConfig.key];
            const bValue = b[sortConfig.key];
            if (aValue < bValue) {
                return sortConfig.direction === "ascending" ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === "ascending" ? 1 : -1;
            }
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastNotification = currentPage * itemsPerPage;
    const indexOfFirstNotification = indexOfLastNotification - itemsPerPage;
    const currentNotifications = sortedNotifications.slice(indexOfFirstNotification, indexOfLastNotification);
    const totalPages = Math.ceil(sortedNotifications.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };


    // Handle show delete modal
    const handleShowDeleteModal = () => {
        if (selectedNotification) {
            setShowDeleteModal(true);
        }
    };

    const handleDeleteNotification = async () => {
        if (selectedNotification) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-notification/${selectedNotification.id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setNotifications(notifications.filter((notification) => notification.id !== selectedNotification.id));
                    setSelectedNotification(null);
                    showAlert("Notification supprimée avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de la notification');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleViderCloche = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/vider-cloche/`, {
                method: 'POST',
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Cloche vidée avec succès !");
            } else {
                console.error('Erreur lors de la suppression des notifications de la cloche.', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setShowClocheModal(false);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }], // En-têtes
            ['bold', 'italic', 'underline'], // Styles de texte
            ['link', 'image'], // Ajouter des liens et des images
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
            ['clean'] // Bouton pour effacer le format
            [{ 'align': [] }], // Alignement du texte
            ['link', 'image'], // Ajouter des liens et des images
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Listes
        ],
    };


    // Pagination logic
    const indexOfLastSimulation = currentPage * itemsPerPage;
    const indexOfFirstSimulation = indexOfLastSimulation - itemsPerPage;




    // Fonction pour définir le style en fonction du statut
    const getStatutStyle = (statut) => {
        switch (statut) {
            case 'Envoyée':
                return 'badge badge-primary';
            case 'En attente':
                return 'badge badge-success';
            default:
                return {};
        }
    };



    // Gestion du clic sur "Voir plus" ou "Voir moins"
    const toggleMessageExpansion = (id) => {
        setExpandedMessages((prev) => ({
            ...prev,
            [id]: !prev[id], // Inverse l'état pour ce message spécifique
        }));
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Notification")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaBell size={25} className='mr-2' /> Gestion des notifications</h2>
                            <small>Administration des notifications.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Liste-notification`}>Notification</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des notifications</h5>
                                <div className='row'>
                                    <Link onClick={handleShowAddModal} className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1">
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Ajouter
                                        </span>
                                    </Link>
                                    <button
                                        onClick={() => handleEnvoyer(selectedNotification)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedNotification && (selectedNotification.statut !== "Envoyée") ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedNotification || (selectedNotification.statut === "Envoyée")} // Désactiver le bouton si aucune notification n'est sélectionnée
                                    >
                                        {isLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <>
                                                <FaPaperPlane />
                                                <span className="d-none d-sm-inline ml-2">
                                                    Envoyer
                                                </span>
                                            </>
                                        )}
                                    </button>
                                    <button
                                        onClick={() => handleShowEditModal(selectedNotification)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedNotification ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedNotification} // Désactiver le bouton si aucune notification n'est sélectionnée
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedNotification ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedNotification}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline">
                                            Supprimer
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowDetailsModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedNotification ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedNotification}
                                    >
                                        <FaUserCheck />
                                        <span className="d-none d-sm-inline ml-2">
                                            Destinataires
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowClocheModal}
                                        className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">
                                            Vider la cloche
                                        </span>
                                    </button>
                                </div>
                            </div>



                            {/* Modal Ajouterrrrrr Notification */}
                            <Modal show={showAddModal} onHide={handleCloseAddModal}>
                                <Modal.Header>
                                    <Modal.Title>Nouvelle notification</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-3 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    <Form onSubmit={handleEnvoyerNotification}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                name="titre"
                                                value={newNotification.titre || ''}
                                                onChange={(e) => {
                                                    setNewNotification({
                                                        ...newNotification,
                                                        titre: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Message</Form.Label>
                                            <SummernoteEditor
                                                value={newNotification.message}
                                                onChange={(content) => {
                                                    setNewNotification({
                                                        ...newNotification,
                                                        message: content, // Mettre à jour l'état de message
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Type de destinataire</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="typeDestinataire"
                                                value={newNotification.typeDestinataire}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Sélectionner un type</option>
                                                <option value="utilisateur">Utilisateur</option>
                                                <option value="groupe">Groupe</option>
                                                <option value="listeDiffusion">Liste de diffusion</option>
                                                <option value="excel">Fichier Excel</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Sélection de l'utilisateur/groupe/liste selon le type de destinataire */}
                                        {newNotification.typeDestinataire === 'utilisateur' && (
                                            <Form.Group className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <Form.Label>Utilisateurs</Form.Label>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => {
                                                            if (newNotification.destinataireDetails?.length === utilisateurs.length) {
                                                                // Si déjà tous sélectionnés, on désélectionne tout
                                                                setNewNotification({
                                                                    ...newNotification,
                                                                    destinataireDetails: []
                                                                });
                                                            } else {
                                                                // Sinon on sélectionne tout
                                                                setNewNotification({
                                                                    ...newNotification,
                                                                    destinataireDetails: [...utilisateurs]
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {newNotification.destinataireDetails?.length === utilisateurs.length
                                                            ? "Tout désélectionner"
                                                            : "Tout sélectionner"}
                                                    </Button>
                                                </div>
                                                <Select
                                                    options={utilisateurs}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={newNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setNewNotification({
                                                            ...newNotification,
                                                            destinataireDetails: selectedOptions,
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                                <div className="mt-1 text-muted small">
                                                    {newNotification.destinataireDetails?.length || 0} utilisateur(s) sélectionné(s)
                                                </div>
                                            </Form.Group>
                                        )}

                                        {newNotification.typeDestinataire === 'groupe' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Groupe</Form.Label>
                                                <Select
                                                    options={groupes}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={newNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setNewNotification({
                                                            ...newNotification,
                                                            destinataireDetails: selectedOptions, // Valeur mise à jour avec un tableau d'objets
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                            </Form.Group>
                                        )}

                                        {newNotification.typeDestinataire === 'listeDiffusion' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Liste de diffusion</Form.Label>
                                                <Select
                                                    options={diffusions}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={newNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setNewNotification({
                                                            ...newNotification,
                                                            destinataireDetails: selectedOptions, // Valeur mise à jour avec un tableau d'objets
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                            </Form.Group>
                                        )}

                                        {newNotification.typeDestinataire === 'excel' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Fichier Excel</Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    accept=".csv, .xlsx, .xls"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            setNewNotification({
                                                                ...newNotification,
                                                                fichierExcel: file,
                                                            });
                                                        }
                                                    }}
                                                    required
                                                />
                                                <Form.Text className="text-muted">
                                                    Le fichier Excel doit contenir une colonne "Email" avec les adresses des destinataires
                                                </Form.Text>
                                            </Form.Group>
                                        )}

                                        {/* Champ Date d'envoi */}
                                        {/* <Form.Group className="mb-3">
                                            <Form.Label>Date d'envoi</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                name="date_envoi"
                                                value={newNotification.date_envoi}
                                                onChange={(e) =>
                                                    setNewNotification({
                                                        ...newNotification,
                                                        date_envoi: e.target.value,
                                                    })
                                                }
                                                required
                                            />
                                        </Form.Group> */}

                                        {/* Section des boutons */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                variant="secondary"
                                                className="me-2 mr-2"
                                                onClick={handleCloseAddModal}
                                            >
                                                Annuler
                                            </Button>
                                            <Button
                                                variant="success"
                                                className="me-2 mr-2"
                                                onClick={() => handleEnregNotification()}
                                            >
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <>
                                                        <FaSave className="mr-2" />
                                                        Enregistrer
                                                    </>
                                                )}

                                            </Button>
                                            {/* <Button variant="success" type="submit">
                                                {isLoading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <>
                                                        <FaPaperPlane className="mr-2" />
                                                        Envoyer
                                                    </>
                                                )}
                                            </Button> */}
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>


                            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                                <Modal.Header>
                                    <Modal.Title>Modifier la notification</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-3 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    <Form onSubmit={handleModifierNotification}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre</Form.Label>
                                            {/* <ReactQuill 
                                                theme="snow" 
                                                value={modifNotification.titre} 
                                                onChange={(content) => {
                                                    setModifNotification({
                                                        ...modifNotification,
                                                        titre: content, // Mettre à jour le titre de l'éditeur
                                                    });
                                                }}
                                                modules={modules} // Appliquez les modules personnalisés
                                            /> */}
                                            <Form.Control
                                                type="text"
                                                required
                                                value={modifNotification.titre}
                                                onChange={(event) => {
                                                    setModifNotification({
                                                        ...modifNotification,
                                                        titre: event.target.value, // Utilisez event.target.value pour obtenir la valeur
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Message</Form.Label>
                                            <SummernoteEditor
                                                value={modifNotification.message}
                                                onChange={(content) => {
                                                    setModifNotification({
                                                        ...modifNotification,
                                                        message: content, // mettez directement le contenu de l'éditeur
                                                    });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Type de destinataire</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="type_destinataire"
                                                value={modifNotification.type_destinataire}
                                                onChange={(e) =>
                                                    setModifNotification({
                                                        ...modifNotification,
                                                        type_destinataire: e.target.value,
                                                    })
                                                }
                                                required
                                            >
                                                <option value="">Sélectionner un type</option>
                                                <option value="utilisateur">Utilisateur</option>
                                                <option value="groupe">Groupe</option>
                                                <option value="listeDiffusion">Liste de diffusion</option>
                                                <option value="excel">Fichier Excel</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Sélection utilisateur/groupe/liste */}
                                        {modifNotification.type_destinataire === 'utilisateur' && (
                                            <Form.Group className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <Form.Label>Utilisateurs</Form.Label>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => {
                                                            if (modifNotification.destinataireDetails?.length === utilisateurs.length) {
                                                                // Si déjà tous sélectionnés, on désélectionne tout
                                                                setModifNotification({
                                                                    ...modifNotification,
                                                                    destinataireDetails: []
                                                                });
                                                            } else {
                                                                // Sinon on sélectionne tout
                                                                setModifNotification({
                                                                    ...modifNotification,
                                                                    destinataireDetails: [...utilisateurs]
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {modifNotification.destinataireDetails?.length === utilisateurs.length
                                                            ? "Tout désélectionner"
                                                            : "Tout sélectionner"}
                                                    </Button>
                                                </div>
                                                <Select
                                                    options={utilisateurs}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={modifNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setModifNotification({
                                                            ...modifNotification,
                                                            destinataireDetails: selectedOptions,
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                                <div className="mt-1 text-muted small">
                                                    {modifNotification.destinataireDetails?.length || 0} utilisateur(s) sélectionné(s)
                                                </div>
                                            </Form.Group>
                                        )}

                                        {modifNotification.type_destinataire === 'groupe' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Groupe</Form.Label>
                                                <Select
                                                    options={groupes}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={modifNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setModifNotification({
                                                            ...modifNotification,
                                                            destinataireDetails: selectedOptions, // Valeur mise à jour avec un tableau d'objets
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                                {/* <pre>{JSON.stringify(modifNotification.destinataire, null, 2)}</pre> */}
                                            </Form.Group>
                                        )}

                                        {modifNotification.type_destinataire === 'listeDiffusion' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Liste de diffusion</Form.Label>
                                                <Select
                                                    options={diffusions}
                                                    name="destinataireDetails"
                                                    isMulti
                                                    value={modifNotification.destinataireDetails}
                                                    onChange={(selectedOptions) => {
                                                        setModifNotification({
                                                            ...modifNotification,
                                                            destinataireDetails: selectedOptions,
                                                        });
                                                    }}
                                                    placeholder="Sélectionner un ou plusieurs utilisateurs"
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                />
                                                {/* <pre>{JSON.stringify(modifNotification.destinataire, null, 2)}</pre> */}
                                            </Form.Group>
                                        )}

                                        {modifNotification.type_destinataire === 'excel' && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Fichier Excel</Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    accept=".csv, .xlsx, .xls"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            setModifNotification({
                                                                ...modifNotification,
                                                                fichierExcel: file,
                                                            });
                                                        }
                                                    }}
                                                />
                                                {/* {modifNotification.fichierNom && (
                                                    <div className="mt-2">
                                                        Fichier actuel: {modifNotification.fichierNom}
                                                    </div>
                                                )} */}
                                            </Form.Group>
                                        )}

                                        {/* Champ Date d'envoi */}
                                        {/* <Form.Group className="mb-3">
                                            <Form.Label>Date d'envoi</Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                name="date_envoi"
                                                value={modifNotification.date_envoi}
                                                onChange={(e) =>
                                                    setModifNotification({
                                                        ...modifNotification,
                                                        date_envoi: e.target.value,
                                                    })
                                                }
                                                required
                                            />
                                        </Form.Group> */}

                                        {/* Boutons */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                variant="secondary"
                                                className="me-2 mr-2"
                                                onClick={handleCloseEditModal}
                                            >
                                                Annuler
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                            >
                                                {isLoading ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                ) : (
                                                    <>
                                                        <FaSave className="mr-2" />
                                                        Enregistrer
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>


                            <Modal
                                show={showDetailsModal}
                                onHide={handleCloseDetailsModal}
                                size="lg"
                            >
                                <Modal.Header className="bg-success text-white">
                                    <Modal.Title>
                                        <FaUserCheck className="mr-2" />
                                        Liste des destinataires
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {modifNotification && (
                                        <div className="container-fluid">

                                            {/* Section Destinataires */}
                                            <div className="row">
                                                <div className="col-12">
                                                    <h5 className="border-bottom pb-2">Destinataires</h5>
                                                    <div className="p-3 bg-light rounded" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                        {modifNotification.destinataire ? (
                                                            modifNotification.destinataire.split(', ').map((email, index) => (
                                                                <div key={index} className="d-flex align-items-center mb-2">
                                                                    <span className="me-2">•</span>
                                                                    <span>{email}</span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-muted">Aucun destinataire trouvé</div>
                                                        )}
                                                    </div>
                                                    <div className="mt-2 text-end">
                                                        <small className="text-muted">
                                                            Total: {modifNotification.destinataire ? modifNotification.destinataire.split(', ').length : 0} destinataires
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer className="bg-light">
                                    <Button
                                        variant="secondary"
                                        onClick={handleCloseDetailsModal}
                                        className="d-flex align-items-center"
                                    >
                                        {/* <FaArrowLeft className="me-2" /> */}
                                        Fermer
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('titre')}>Titre{sortConfig.key === 'titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('message')}>Message {sortConfig.key === 'message'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('type_destinataire')}>Type destinataire {sortConfig.key === 'type_destinataire'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_creation')}>Date création {sortConfig.key === 'date_creation'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('date_envoi')}>Date envoi {sortConfig.key === 'date_envoi'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('status')}>Statut {sortConfig.key === 'status'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    {!isGlobaleLoading ? (

                                                        <tbody>
                                                            {currentNotifications.length > 0 ? currentNotifications.map((n) => (
                                                                <tr
                                                                    key={n.id}
                                                                    className={`bg-white ${selectedNotification && selectedNotification.id === n.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(n)}
                                                                >
                                                                    <td><span dangerouslySetInnerHTML={{ __html: n.titre }}></span></td>
                                                                    <td>
                                                                        {/* Afficher le message avec le bouton Voir plus/Voir moins */}
                                                                        {expandedMessages[n.id] ? (
                                                                            <>
                                                                                <span dangerouslySetInnerHTML={{ __html: n.message }}></span>
                                                                                <button
                                                                                    onClick={() => toggleMessageExpansion(n.id)}
                                                                                    className="btn btn-link text-primary p-0 ms-2"
                                                                                >
                                                                                    Voir moins
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: n.message.length > 100
                                                                                            ? n.message.substring(0, 100) + "..."
                                                                                            : n.message,
                                                                                    }}
                                                                                ></span>
                                                                                {n.message.length > 100 && (
                                                                                    <button
                                                                                        onClick={() => toggleMessageExpansion(n.id)}
                                                                                        className="btn btn-link text-primary p-0 ms-2"
                                                                                    >
                                                                                        Voir plus
                                                                                    </button>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td>{n.type_destinataire}</td>
                                                                    <td>{new Date(n.date_creation).toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                                                    <td>{new Date(n.date_envoi).toLocaleString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                                                                    {/* <td>{n.date_creation}</td>
            <td>{n.date_envoi}</td> */}
                                                                    <td>
                                                                        <span className={getStatutStyle(n.statut)} style={{ textTransform: 'capitalize' }}>
                                                                            {n.statut}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="5">Aucune notification à afficher</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}

                                                </table>
                                            </div>
                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className="dataTables_info" role="status" aria-live="polite">
                                                    {`Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div> */}
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSimulation + 1} à ${Math.min(indexOfLastSimulation, totalItems)} sur ${totalItems}`}
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal de confirmation de suppression */}
                <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                    <Modal.Header>
                        <Modal.Title>Confirmer la suppression</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Êtes-vous sûr de vouloir supprimer cette notification ?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>Annuler</Button>
                        <Button variant="success" onClick={handleDeleteNotification}>Supprimer</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showClocheModal} onHide={handleCloseClocheModal}>
                    <Modal.Header>
                        <Modal.Title>Cloche de notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Cette action sert à vider les notifications de la cloche. Voulez-vous continuer ?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="me-2 mr-2"
                            onClick={handleCloseClocheModal}
                        >
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleViderCloche}
                        >
                            Confirmer
                        </Button>
                    </Modal.Footer>

                </Modal>
            </div>
        </div>
    );
};

export default Liste_notifications;
